<template>
  <el-dialog v-dialog-window="resizeDialogMap" :title="readonly ? '查看运单围栏' : isUpdate ? '编辑运单围栏' : '新增运单围栏'" :visible.sync="dialogVisible" width="80rem" append-to-body :close-on-click-modal="false" @open="onOpen" @closed="onClosed">
    <div class="waybill-fence-editor">
      <div ref="mapEl" class="waybill-fence-editor__map" />
      <div v-if="!readonly" class="waybill-fence-editor__search">
        <el-autocomplete
          v-model.trim="placeKeyword"
          class="search-place"
          :fetch-suggestions="querySearchAsync"
          placeholder="搜索地点"
          size="small"
          clearable
          popper-append-to-body
          :trigger-on-focus="false"
          :highlight-first-item="true"
          @select="onSearchSelect"
          @keyup.enter.native="searchPlace"
        >
          <el-button slot="append" icon="el-icon-search" @click="searchPlace" />
        </el-autocomplete>
        <el-input v-model.trim="coordKeyword" class="search-coord" size="small" clearable placeholder="经度,纬度" @keyup.enter.native="locateByCoord" />
        <el-button size="small" icon="el-icon-aim" @click="locateByCoord">定位</el-button>
      </div>

      <aside class="waybill-fence-editor__panel">
        <div v-if="!readonly" class="panel-section">
          <div class="panel-title">围栏形状</div>
          <div class="shape-actions">
            <el-button size="small" :type="form.fenceType === 1 ? 'primary' : 'default'" @click="selectShape(1)">圆形围栏</el-button>
            <el-button size="small" :type="form.fenceType === 2 ? 'primary' : 'default'" @click="selectShape(2)">多边形围栏</el-button>
          </div>
          <div class="panel-tip">点击地图设置位置，启用编辑后可拖动圆形或调整多边形顶点。</div>
        </div>

        <el-alert v-if="mapNotice" :title="mapNotice" type="warning" :closable="false" show-icon />
        <el-form ref="form" :model="form" :rules="rules" label-position="top" size="small" class="fence-form">
          <el-form-item v-if="readonly" label="围栏形状">
            <span>{{ Number(form.fenceType) === 1 ? '圆形围栏' : Number(form.fenceType) === 2 ? '多边形围栏' : '未知' }}</span>
          </el-form-item>
          <el-form-item v-if="readonly" label="状态">
            <span>{{ Number(form.status) === 1 && !Number(form.deleted) ? '正常' : '禁用' }}</span>
          </el-form-item>
          <el-form-item label="围栏名称" prop="fenceName">
            <el-input v-model.trim="form.fenceName" maxlength="100" :disabled="readonly" placeholder="请输入围栏名称" />
          </el-form-item>
          <el-form-item label="围栏编码" prop="fenceCode">
            <el-input v-model.trim="form.fenceCode" maxlength="64" :disabled="readonly || isUpdate" placeholder="请输入围栏编码">
              <el-button v-if="!readonly && !isUpdate" slot="append" @click="generateFenceCode">生成</el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="事件类型" prop="eventType">
            <el-select v-model="form.eventType" style="width: 100%" :disabled="readonly" placeholder="请选择事件类型">
              <el-option label="驶入" :value="1" />
              <el-option label="驶出" :value="2" />
              <el-option label="区域内停车" :value="3" />
              <el-option label="驶入+驶出" :value="4" />
              <el-option label="驶入+驶出+驶出超时" :value="5" />
              <el-option label="驶入+区域内停车" :value="6" />
              <el-option label="驶入+驶出+区域内停车" :value="7" />
              <el-option label="驶入+驶出+区域内停车+驶出超时" :value="8" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="requiresParkingMinutes" label="连续停车时长（分钟）" required>
            <el-input-number :value="form.parkingMinutes == null ? undefined : form.parkingMinutes" @input="form.parkingMinutes = $event" :min="1" :max="2147483647" :precision="0" :disabled="readonly" controls-position="right" placeholder="请输入连续停车时长" style="width: 100%" />
          </el-form-item>
          <el-form-item v-if="requiresExitTimeoutMinutes" label="驶出时限（分钟）" required>
            <el-input-number :value="form.exitTimeoutMinutes == null ? undefined : form.exitTimeoutMinutes" @input="form.exitTimeoutMinutes = $event" :min="1" :max="2147483647" :precision="0" :disabled="readonly" controls-position="right" placeholder="请输入驶出时限" style="width: 100%" />
          </el-form-item>
          <el-form-item :label="form.fenceType === 1 ? '圆心坐标' : '顶点坐标'">
            <el-input :value="displayFenceCoords" type="textarea" :rows="form.fenceType === 1 ? 1 : 3" readonly :placeholder="form.fenceType === 1 ? '请在地图上点击设置圆心' : '请在地图上绘制多边形'" />
          </el-form-item>
          <el-form-item v-if="form.fenceType === 1" label="半径（米）">
            <el-input :value="form.fenceRadius ? form.fenceRadius + ' 米' : ''" readonly placeholder="请在地图上绘制圆形围栏" />
          </el-form-item>
        </el-form>

        <div v-if="!readonly" class="panel-actions">
          <el-button size="small" @click="clearFence">清除</el-button>
          <el-button size="small" :type="editing ? 'primary' : 'default'" @click="toggleEdit">{{ editing ? '结束编辑' : '启用编辑' }}</el-button>
        </div>
        <div class="panel-footer">
          <el-button size="small" @click="dialogVisible = false">{{ readonly ? '关闭' : '取消' }}</el-button>
          <el-button v-if="!readonly" v-permission="isUpdate ? 'fence:edit' : 'fence:add'" type="primary" size="small" :loading="saving" @click="submit">保存</el-button>
        </div>
      </aside>
    </div>
  </el-dialog>
</template>

<script>
import dayjs from 'dayjs'
import { loadAmapSDK, setAmapSecurityConfig } from '@/utils/amapConfig'
import { formatLonLat, parseLonLat, gcj02PointToWgs84LonLat, wgs84RouteToGcj02, wgs84RouteToGcj02Text } from './coordinate'

/* global AMap */
const DEFAULT_CENTER = [116.397428, 39.90923]
const DEFAULT_RADIUS = 500
const FENCE_STYLE = {
  strokeColor: '#3388ff',
  strokeWeight: 2,
  strokeOpacity: 1,
  fillColor: '#99c7ff',
  fillOpacity: 0.35
}

const createForm = () => ({
  fenceName: '',
  fenceCode: '',
  fenceType: 1,
  fenceCoords: '',
  fenceRadius: DEFAULT_RADIUS,
  eventType: 1,
  parkingMinutes: null,
  exitTimeoutMinutes: null,
  status: 1,
  effectiveStartTime: null,
  effectiveEndTime: null
})

export default {
  name: 'WaybillFenceDialog',
  props: {
    visible: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    fence: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      dialogVisible: false,
      form: createForm(),
      rules: {
        fenceName: [{ required: true, message: '请输入围栏名称', trigger: 'blur' }],
        fenceCode: [{ required: true, message: '请生成或输入围栏编码', trigger: 'blur' }],
        eventType: [{ required: true, message: '请选择事件类型', trigger: 'change' }]
      },
      placeKeyword: '',
      coordKeyword: '',
      map: null,
      overlay: null,
      circleEditor: null,
      polygonEditor: null,
      editing: false,
      mapClickHandler: null,
      mapInitId: 0,
      mapNotice: ''
    }
  },
  computed: {
    isUpdate() { return Boolean(this.fence && this.fence.fenceCode) },
    // 只转换显示值，保存时保留内部 WGS84 原值，避免反复编辑发生漂移。
    displayFenceCoords() { return wgs84RouteToGcj02Text(this.form.fenceCoords) },
    requiresParkingMinutes() { return [3, 6, 7, 8].includes(Number(this.form.eventType)) },
    requiresExitTimeoutMinutes() { return [5, 8].includes(Number(this.form.eventType)) }
  },
  watch: {
    visible: {
      immediate: true,
      handler(value) { this.dialogVisible = value }
    },
    dialogVisible(value) { this.$emit('update:visible', value) }
  },
  beforeDestroy() { this.destroyMap() },
  methods: {
    resizeDialogMap() { if (this.map) this.map.resize() },
    onOpen() {
      this.resetForm()
      this.$nextTick(() => {
        const loading = this.initMap()
        const mapInitId = this.mapInitId
        loading.catch(() => {
          if (mapInitId !== this.mapInitId) return
          this.mapNotice = '地图加载失败，请稍后重试'
          this.$message.error(this.mapNotice)
        })
      })
    },
    onClosed() { this.destroyMap() },
    resetForm() {
      this.form = this.readonly || this.isUpdate ? { ...createForm(), ...this.fence } : createForm()
      if (this.readonly && this.fence.fenceRadius == null) this.form.fenceRadius = null
      this.mapNotice = ''
      if (!this.readonly && !this.isUpdate) this.generateFenceCode()
      this.placeKeyword = ''
      this.coordKeyword = ''
      this.editing = false
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    generateFenceCode() {
      const random = String(Math.floor(Math.random() * 10000)).padStart(4, '0')
      this.form.fenceCode = `FENCE${dayjs().format('YYYYMMDDHHmmss')}${random}`
    },
    async initMap() {
      this.destroyMap()
      const mapInitId = this.mapInitId
      setAmapSecurityConfig()
      await loadAmapSDK(['AMap.CircleEditor', 'AMap.PolygonEditor', 'AMap.AutoComplete', 'AMap.Geocoder', 'AMap.Scale', 'AMap.ToolBar'])
      if (mapInitId !== this.mapInitId) return
      this.map = new AMap.Map(this.$refs.mapEl, {
        zoom: 12,
        center: DEFAULT_CENTER,
        resizeEnable: true,
        mapStyle: 'amap://styles/6e581a480732b7393cf1f6f02c9c4c5a'
      })
      this.map.addControl(new AMap.Scale())
      this.map.addControl(new AMap.ToolBar())
      this.mapClickHandler = (event) => {
        if (this.readonly) return
        if (!event || !event.lnglat) return
        this.setFenceCenter(event.lnglat.getLng(), event.lnglat.getLat())
      }
      this.map.on('click', this.mapClickHandler)
      this.renderReadonlyFence()
    },
    destroyMap() {
      this.mapInitId += 1
      this.closeEditors()
      if (this.map && this.mapClickHandler) this.map.off('click', this.mapClickHandler)
      this.mapClickHandler = null
      if (this.map) this.map.destroy()
      this.map = null
      this.overlay = null
    },
    selectShape(type) {
      if (this.readonly) return
      if (this.form.fenceType === type) return
      this.form.fenceType = type
      if (!this.map) return
      this.placeFence(this.getMapCenter())
    },
    getMapCenter() {
      if (!this.map) return DEFAULT_CENTER
      const center = this.map.getCenter()
      return center ? [center.getLng(), center.getLat()] : DEFAULT_CENTER
    },
    setFenceCenter(lng, lat) {
      if (this.readonly) return
      if (!this.map) return
      if (!this.overlay) {
        this.placeFence([lng, lat])
        return
      }
      if (this.form.fenceType === 1) {
        this.overlay.setCenter([lng, lat])
        this.syncCircle()
      } else {
        this.overlay.setPath(this.buildTriangle([lng, lat]))
        this.syncPolygon()
      }
      if (this.editing) this.openEditor()
    },
    placeFence(center) {
      if (!this.map) return
      this.clearOverlay()
      if (this.form.fenceType === 1) {
        this.overlay = new AMap.Circle({ ...FENCE_STYLE, center, radius: DEFAULT_RADIUS, zIndex: 10 })
        this.map.add(this.overlay)
        this.syncCircle()
      } else {
        this.overlay = new AMap.Polygon({ ...FENCE_STYLE, path: this.buildTriangle(center), zIndex: 10 })
        this.map.add(this.overlay)
        this.syncPolygon()
      }
    },
    clearOverlay() {
      this.closeEditors()
      if (this.map && this.overlay) this.map.remove(this.overlay)
      this.overlay = null
      this.form.fenceCoords = ''
      this.form.fenceRadius = DEFAULT_RADIUS
    },
    clearFence() { if (!this.readonly) this.clearOverlay() },
    buildTriangle(center) {
      return [0, 120, 240].map((bearing) => this.offsetPoint(center[0], center[1], DEFAULT_RADIUS, bearing))
    },
    offsetPoint(lng, lat, distance, bearing) {
      const radius = 6378137
      const angle = bearing * Math.PI / 180
      const lat1 = lat * Math.PI / 180
      const lon1 = lng * Math.PI / 180
      const lat2 = Math.asin(Math.sin(lat1) * Math.cos(distance / radius) + Math.cos(lat1) * Math.sin(distance / radius) * Math.cos(angle))
      const lon2 = lon1 + Math.atan2(Math.sin(angle) * Math.sin(distance / radius) * Math.cos(lat1), Math.cos(distance / radius) - Math.sin(lat1) * Math.sin(lat2))
      return [lon2 * 180 / Math.PI, lat2 * 180 / Math.PI]
    },
    formatPoint(lng, lat) { return gcj02PointToWgs84LonLat(lng, lat) },
    syncCircle() {
      if (!this.overlay) return
      const center = this.overlay.getCenter()
      this.form.fenceCoords = this.formatPoint(center.getLng(), center.getLat())
      this.form.fenceRadius = Math.round(this.overlay.getRadius())
    },
    syncPolygon() {
      if (!this.overlay) return
      this.form.fenceCoords = this.overlay.getPath().map((point) => this.formatPoint(point.getLng(), point.getLat())).join('|')
      this.form.fenceRadius = null
    },
    toggleEdit() {
      if (this.readonly) return
      if (!this.overlay) {
        this.$message.warning('请先在地图上点击设置围栏')
        return
      }
      if (this.editing) this.closeEditors()
      else this.openEditor()
    },
    closeEditors() {
      if (this.circleEditor) this.circleEditor.close()
      if (this.polygonEditor) this.polygonEditor.close()
      this.circleEditor = null
      this.polygonEditor = null
      this.editing = false
    },
    openEditor() {
      if (this.readonly) return
      this.closeEditors()
      if (!this.map || !this.overlay) return
      this.editing = true
      if (this.form.fenceType === 1) {
        this.circleEditor = new AMap.CircleEditor(this.map, this.overlay)
        const sync = () => this.syncCircle()
        this.circleEditor.on('adjust', sync)
        this.circleEditor.on('move', sync)
        this.circleEditor.open()
      } else {
        this.polygonEditor = new AMap.PolygonEditor(this.map, this.overlay)
        const sync = () => this.syncPolygon()
        this.polygonEditor.on('adjust', sync)
        this.polygonEditor.on('addnode', sync)
        this.polygonEditor.on('removenode', sync)
        this.polygonEditor.open()
      }
    },
    parseCoord(value) {
      return parseLonLat(String(value || '').trim().replace(/\s*,\s*/g, ',').replace(/\s+/g, ','))
    },
    locateByCoord() {
      const point = this.parseCoord(this.coordKeyword)
      if (!point) {
        this.$message.warning('请输入有效经纬度，格式：经度,纬度')
        return
      }
      this.map.setCenter(point)
      this.map.setZoom(15)
      // 原样回填圆心只定位地图，保留原 WGS84 和图形，避免近似逆转换漂移。
      if (Number(this.form.fenceType) === 1 && formatLonLat(point) === this.displayFenceCoords) return
      this.setFenceCenter(point[0], point[1])
    },
    querySearchAsync(queryString, callback) {
      const keyword = String(queryString || '').trim()
      if (!keyword || !window.AMap) {
        callback([])
        return
      }
      AMap.plugin('AMap.AutoComplete', () => {
        new AMap.AutoComplete({ city: '全国', citylimit: false }).search(keyword, (status, result) => {
          if (status !== 'complete' || !result || result.info !== 'OK' || !result.tips) {
            callback([])
            return
          }
          callback(result.tips.filter((tip) => tip && (tip.name || tip.address)).slice(0, 10).map((tip) => ({
            value: this.formatSearchTipLabel(tip),
            keyword: tip.name || tip.address || '',
            location: tip.location || null
          })))
        })
      })
    },
    formatSearchTipLabel(tip) {
      const name = tip.name || tip.address || ''
      const address = tip.address && tip.address !== name ? tip.address : ''
      return address ? `${name}（${address}）` : name
    },
    parseTipLocation(location) {
      if (!location) return null
      if (typeof location === 'string') return this.parseCoord(location)
      const lng = typeof location.getLng === 'function' ? location.getLng() : location.lng
      const lat = typeof location.getLat === 'function' ? location.getLat() : location.lat
      return Number.isFinite(lng) && Number.isFinite(lat) ? [lng, lat] : null
    },
    onSearchSelect(item) {
      const point = this.parseTipLocation(item && item.location)
      if (point) {
        this.applySearchLocation(point[0], point[1])
        return
      }
      this.searchByKeyword(item && item.keyword ? item.keyword : this.placeKeyword)
    },
    applySearchLocation(lng, lat) {
      if (!this.map) return
      this.map.setCenter([lng, lat])
      this.map.setZoom(15)
      this.coordKeyword = formatLonLat([lng, lat])
      this.setFenceCenter(lng, lat)
    },
    searchPlace() { this.searchByKeyword(this.placeKeyword) },
    searchByKeyword(value) {
      if (this.readonly) return
      const keyword = String(value || '').trim()
      if (!keyword || !this.map) return
      new AMap.Geocoder().getLocation(keyword, (status, result) => {
        if (status !== 'complete' || !result.geocodes || !result.geocodes.length) {
          this.$message.warning('未找到相关地点')
          return
        }
        const point = result.geocodes[0].location
        this.applySearchLocation(point.getLng(), point.getLat())
      })
    },
    submit() {
      if (this.readonly) return
      this.$refs.form.validate((valid) => {
        if (!valid) return
        if (!this.form.fenceCoords) {
          this.$message.warning('请在地图上设置围栏')
          return
        }
        if (this.requiresParkingMinutes && !this.validMinutes(this.form.parkingMinutes)) {
          this.$message.warning('连续停车时长必须是1至2147483647的整数分钟')
          return
        }
        if (this.requiresExitTimeoutMinutes && !this.validMinutes(this.form.exitTimeoutMinutes)) {
          this.$message.warning('驶出时限必须是1至2147483647的整数分钟')
          return
        }
        this.$emit('submit', {
          ...this.form,
          parkingMinutes: this.requiresParkingMinutes ? Number(this.form.parkingMinutes) : null,
          exitTimeoutMinutes: this.requiresExitTimeoutMinutes ? Number(this.form.exitTimeoutMinutes) : null
        })
      })
    },
    validMinutes(value) {
      return value !== null && value !== '' && Number.isInteger(Number(value)) && Number(value) >= 1 && Number(value) <= 2147483647
    },
    renderReadonlyFence() {
      if (!this.map) return
      const points = wgs84RouteToGcj02(this.form.fenceCoords || '')
      const type = Number(this.form.fenceType)
      if ((type === 1 && (!points.length || !(Number(this.form.fenceRadius) > 0)))
          || (type === 2 && points.length < 3) || ![1, 2].includes(type)) {
        if (this.readonly) this.mapNotice = '未记录有效几何范围，可查看围栏文字资料'
        return
      }
      if (Number(this.form.fenceType) === 1) {
        this.overlay = new AMap.Circle({ ...FENCE_STYLE, center: points[0], radius: Number(this.form.fenceRadius) || DEFAULT_RADIUS, zIndex: 10 })
      } else {
        this.overlay = new AMap.Polygon({ ...FENCE_STYLE, path: points, zIndex: 10 })
      }
      this.map.add(this.overlay)
      this.map.setFitView([this.overlay])
    }
  }
}
</script>

<style scoped>
.waybill-fence-editor { position: relative; height: 45rem; max-height: calc(100vh - 11rem); overflow: hidden; border-radius: 4px; }
::v-deep .dialog-window > .el-dialog__body { display: flex; flex-direction: column; overflow: hidden; }
::v-deep .dialog-window .waybill-fence-editor { height: auto; min-height: 0; max-height: none; flex: 1; }
.waybill-fence-editor__map { position: absolute; inset: 0; width: 100%; height: 100%; }
.waybill-fence-editor__search { position: absolute; top: 12px; left: 12px; z-index: 10; display: flex; gap: 8px; padding: 8px; background: #fff; border-radius: 4px; box-shadow: 0 2px 8px rgba(0, 0, 0, .12); }
.search-place { width: 210px; }
.search-coord { width: 150px; }
.waybill-fence-editor__panel { position: absolute; top: 12px; right: 12px; bottom: 12px; z-index: 10; display: flex; flex-direction: column; width: 280px; padding: 12px; box-sizing: border-box; overflow: hidden; background: #f5f7fa; border-radius: 6px; box-shadow: 0 4px 16px rgba(0, 0, 0, .12); }
.panel-section { margin-bottom: 10px; }
.panel-title { margin-bottom: 8px; font-size: 14px; font-weight: 600; color: #303133; }
.shape-actions, .panel-actions, .panel-footer { display: flex; gap: 8px; }
.panel-tip { margin-top: 8px; line-height: 18px; color: #909399; font-size: 12px; }
.fence-form { flex: 1; min-height: 0; overflow-y: auto; }
.fence-form .el-form-item { margin-bottom: 12px; }
.panel-actions { padding-top: 8px; border-top: 1px solid #e4e7ed; }
.panel-footer { justify-content: flex-end; margin-top: 12px; }
@media (max-width: 768px) {
  .waybill-fence-editor__panel { width: 230px; }
  .waybill-fence-editor__search { right: 12px; flex-wrap: wrap; }
}
</style>
